<img class="spinner"
     alt="Loading"
     fetchpriority="high"
     src="/content/ux/loading-spinner/assets/loading-spinner.svg" />
